<template>
  <div class="component">
    <form-status :v="$v" />
    <div>
      <div class="form-group"><engine-details product-type="commercial" :v="$v" /></div>
      <div v-if="checkVisibility()" class="row form-group">
        <div class="col-md-12">
          <label class="required" for="fleetSummaryFileUpload">
            Please attach a fleet summary with ESN and Tail Numbers: (Click here to download the
            <a href="/access/api/aob/getFleetSummarySheet" target="_blank">template</a>)
          </label>
          <file-upload
            upload-section="productInfo"
            document-type="CommercialFleetSummaryDocument"
            :document-name="commercialFleetSummaryDocument"
            :document-status="getDocumentStatus('CommercialFleetSummaryDocument')"
            product-type="commercial"
            :v="$v.commercialFleetSummaryDocument"
          />
        </div>
      </div>
      <div v-if="checkAocVisibility()" class="form-group row">
        <div class="col-md-12">
          <label class="checkbox-inline">
            <input v-model="productTypes.commercial.productInfo.noAirOperatorCertificate" type="checkbox" />
            Please select if you do not have an "Air Operator Certificate" or "Air Carrier Certificate".
          </label>
        </div>
      </div>
      <transition name="fade">
        <div
          v-if="!productTypes.commercial.productInfo.noAirOperatorCertificate && checkAocVisibility()"
          class="row form-group ml"
        >
          <div class="col-md-6 operatorCertificate">
            <label class="text-normal required" for="operatorCertFileUpload">
              Please attach Air Operator Certificate Or Air Carrier Certificate:
              <tooltip
                content="An air operator's certificate (AOC) or Air Carrier Certificate (ACC) is granted by a civil aviation authority (CAA) to an aircraft operator to allow it to use the aircraft(s) for commercial purposes."
                effect="scale"
                placement="right"
              ><i class="fa fa-question-circle"></i>
              </tooltip>
            </label>
            <!-- display uploaded file -->
            <file-upload
              upload-section="productInfo"
              document-type="CommercialOperatorCertificate"
              :document-name="commercialOperatorCertificate"
              :document-status="getDocumentStatus('CommercialOperatorCertificate')"
              product-type="commercial"
              :v="$v.commercialOperatorCertificate"
            />
          </div>
          <div class="col-md-6">
            <label class="text-normal required" for="operatorCertFileUpload">
              Please attach Operator Specification:
              <tooltip
                content="This document is issued to an operator by a civil aviation authority (CAA) and specifies the authorizations, conditions, and limitations associated with the Air Operator Certificate (AOC) or Air Carrier Certificate (ACC) and is subject to the conditions in the operations manual."
                effect="scale"
                placement="right"
              ><i class="fa fa-question-circle"></i>
              </tooltip>
            </label>
            <!-- display uploaded file -->
            <file-upload
              upload-section="productInfo"
              document-type="CommercialOperatorSpecDocument"
              :document-name="commercialOperatorSpecDocument"
              :document-status="getDocumentStatus('CommercialOperatorSpecDocument')"
              product-type="commercial"
              :v="$v.commercialOperatorSpecDocument"
            />
          </div>
        </div>
        <div
          v-if="productTypes.commercial.productInfo.noAirOperatorCertificate && checkVisibilityForAttchment()"
          class="row form-group ml"
        >
          <div class="col-md-6 operatorCertificate">
            <label class="text-normal required" for="operatorCertFileUpload">
              Please attach Lease agreement demonstrating intent to operate the aircraft:
            </label>
            <!-- display uploaded file -->
            <file-upload
              upload-section="productInfo"
              document-type="LeaseAgreementCertificate"
              :document-name="leaseAgreementCertificate"
              :document-status="getDocumentStatus('LeaseAgreementCertificate')"
              product-type="commercial"
              :v="$v.leaseAgreementCertificate"
            />
          </div>
        </div>
      </transition>
      <div class="form-group row col-md-12" v-if="commercialOperatorCertificate != ''">
        <label for="companyNameListedOnAOCorACC" class="control-label required">
          Is your company's name listed on the Air Operator Certificate or Air Carrier Certificate you have provided?
        </label>        
        <div class="aoc-radio-btns mb-3">
          <label class="radio-inline">
            <input id="companyNameListedOnAOCorACCYes" v-model="companyNameListedOnAOCorACC" type="radio" value="Yes" @blur="$v.companyNameListedOnAOCorACC.$touch();"/>
            <span>Yes</span>
          </label>
          <label class="radio-inline">
            <input id="companyNameListedOnAOCorACCNo" v-model="companyNameListedOnAOCorACC" type="radio" value="No" @blur="$v.companyNameListedOnAOCorACC.$touch();"/>
            <span>No</span>
          </label>
        </div>
        <div v-if="!$v.companyNameListedOnAOCorACC.required && $v.companyNameListedOnAOCorACC.$error" class="text-danger row-padding-left">
            Please select if company is listed on AOC or ACC
        </div>
      </div>
      <div class="form-group row col-md-12" v-if="commercialOperatorCertificate != '' && companyNameListedOnAOCorACC === 'No'">
        <label class="required" for="commercialRelationshipDocument">
          Please attach Relationship Document
          <tooltip
            content="If your company's name is not on the Air Operator Certificate (AOC) or Air Carrier Certificate (ACC) you provided, please provide documentation indicating your company's relationship with the company listed on the Air Operator Certificate."
            effect="scale"
            placement="right"
           ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
        <!-- display uploaded file -->
        <file-upload
          upload-section="productInfo"
          document-type="CommercialRelationshipDocument"
          :document-name="commercialRelationshipDocument"
          product-type="commercial"
          :document-status="getDocumentStatus('CommercialRelationshipDocument')"
          :v="$v.commercialRelationshipDocument"
          />
      </div>
      <!--
        Add condition if the user selected lessor for Airline
        then only the below blocks will be displayed
      -->
      <div v-if="checkBOSVisibility()" class="form-group row">
        <div class="col-md-12">
          <label class="checkbox-inline">
            <input
              v-model="productTypes.commercial.productInfo.billOfSale"
              type="checkbox"
              true-value="yes"
              false-value="no"
            />
            <span v-if="productTypes.commercial.companyDetails.companyTypeId != '3'"
              >Please select if you have bill of sale.</span
            >
            <span v-if="productTypes.commercial.companyDetails.companyTypeId == '3'"
              >Please select if you have a "Bill of Sale" document with your company's legal name on it.</span
            >
          </label>
          <div v-if="productTypes.commercial.companyDetails.companyTypeId == '3'">
            <p v-if="productTypes.commercial.productInfo.billOfSale == 'no'" style="margin-left:20px">
              If you company's legal name is not on the Bill of Sale or you are an asset manager, please attach:
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="productTypes.commercial.productInfo.billOfSale == 'yes' && checkBOSVisibility()"
        class="form-group row ml"
      >
        <div class="col-md-12">
          <label
            v-if="
              productTypes.commercial.companyDetails.companyTypeId == '3' &&
                productTypes.commercial.productInfo.billOfSale == 'yes'
            "
            class="text-normal required"
            for="bosFileUpload"
          >
            If you are an aircraft owner, please attach a Bill of Sale:
            <tooltip
                content="This document is issued by the seller (manufacturer or previous owner) to the current owner of the aircraft/engine and proves that current owner has possession or the right to be in possession of the aircraft(s)/engine(s). The Bill of Sale should have your company's name listed as the Lessor. If you do not have this document or the Buyer listed on the Bill of Sale is not your company, you will need to provide a relationship document to indicate your relationship to the Buyer."
                effect="scale"
                placement="right"
              ><i class="fa fa-question-circle"></i>
            </tooltip>
          </label>
          <label v-else class="text-normal required" for="bosFileUpload"> Please attach a bill of sale: </label>
          <!-- display uploaded file -->
          <file-upload
            upload-section="productInfo"
            document-type="BillOfSaleDocument"
            :document-name="billOfSaleDocument"
            :document-status="getDocumentStatus('BillOfSaleDocument')"
            product-type="commercial"
            :v="$v.billOfSaleDocument"
          />
        </div>
      </div>
      <div
        v-if="productTypes.commercial.productInfo.billOfSale == 'no' && checkBOSVisibility()"
        class="row form-group ml"
      >
        <div class="col-md-6 assetFileUpload">
          <label class="text-normal required" for="operatorCertFileUpload">
            Relationship document between aircraft owner and asset manager:
            <tooltip
                content="Please provide a documentation indicating your company's relationship with the aircraft owner if: (1) You don't have a Bill of Sale / Your company's legal name is not on the Bill of Sale; or (2) You are an asset manager."
                effect="scale"
                placement="right"
              ><i class="fa fa-question-circle"></i>
            </tooltip>
          </label>
          <file-upload
            upload-section="productInfo"
            document-type="AssetDocument"
            :document-name="assetDocument"
            :document-status="getDocumentStatus('AssetDocument')"
            product-type="commercial"
            :v="$v.assetDocument"
          />
        </div>
        <div class="col-md-6">
          <label class="text-normal required" for="operatorCertFileUpload">
            <span v-if="productTypes.commercial.companyDetails.companyTypeId != '3'"
              >Letter of authorization from asset manager:</span
            >
            <span v-if="productTypes.commercial.companyDetails.companyTypeId == '3'"
              >Letter of authorization from aircraft owner:
            </span>
            <tooltip
              content="If your company is not the owner of the aircraft, please provide a letter of authorization from the owner designating your company to manage the asset on behalf of the owner."
              effect="scale"
              placement="right"
              ><i class="fa fa-question-circle"></i
            ></tooltip>
          </label>
          <file-upload
            upload-section="productInfo"
            document-type="AuthLetterDocument"
            :document-name="authLetterDocument"
            :document-status="getDocumentStatus('AuthLetterDocument')"
            product-type="commercial"
            :v="$v.authLetterDocument"
          />
        </div>
      </div>
      <div v-if="checkVisibility()" class="form-group row">
        <div class="col-md-12">
          <label class="checkbox-inline">
            <input
              v-model="productTypes.commercial.productInfo.maintServiceProvider"
              true-value="yes"
              false-value="no"
              type="checkbox"
            />
            Please select if you have a maintenance service provider for your fleet
          </label>
        </div>
      </div>
      <div v-if="productTypes.commercial.productInfo.maintServiceProvider == 'yes'" class="row form-group">
        <label class="col-md-12 text-normal required" for="fleetServiceDetails"
          >Please provide the name of your service provider along with detailed address and primary contact name, phone
          number, and email address. :
        </label>
        <div class="col-md-4">
          <textarea
            v-model.trim="productTypes.commercial.productInfo.serviceProviderDetails"
            class="form-control"
            name="fleetServiceDetails"
            @blur="$v.productTypes.commercial.productInfo.serviceProviderDetails.$touch()"
          ></textarea>
          <div
            v-if="
              !$v.productTypes.commercial.productInfo.serviceProviderDetails.required &&
                $v.productTypes.commercial.productInfo.serviceProviderDetails.$error
            "
            class="text-danger"
          >
            This field cannot be empty
          </div>
          <div
            v-if="
              !$v.productTypes.commercial.productInfo.serviceProviderDetails.maxLength &&
                $v.productTypes.commercial.productInfo.serviceProviderDetails.$error
            "
            class="text-danger"
          >
            Allowed upto 500 characters only
          </div>
        </div>
      </div>
      <div class="action-btns">
        <input type="submit" class="btn btn-sm btn-primary" value="Next" @click="gotoNextSection" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import tooltip from "build-ui-x/src/Tooltip";
import engineDetails from "@/mycfm/components/new-company/EngineDetails";
import fileUpload from "@/mycfm/components/new-company/FileUpload";
import { required, requiredIf, numeric, maxLength } from "vuelidate/lib/validators";
import formStatus from "@/mycfm/components/new-company/FormStatus";

export default {
  components: {
    tooltip,
    fileUpload,
    engineDetails,
    formStatus
  },
  computed: {
    ...mapState("product", ["productTypes"]),
    commercialFleetSummaryDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "CommercialFleetSummaryDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    commercialOperatorCertificate() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "CommercialOperatorCertificate") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    leaseAgreementCertificate() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "LeaseAgreementCertificate") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    commercialOperatorSpecDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "CommercialOperatorSpecDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    billOfSaleDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "BillOfSaleDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    assetDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "AssetDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    authLetterDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "AuthLetterDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    commercialRelationshipDocument() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "CommercialRelationshipDocument") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    },
    companyNameListedOnAOCorACC: {
      get() {
        return this.$store.state.product.productTypes["commercial"].productInfo.companyNameListedOnAOCorACC
      },
      set(value) {
        this.$store.dispatch("files/removeFile", "CommercialRelationshipDocument");
        this.$store.dispatch("product/removeFileMetaData", {
          productType: "commercial",
          documentType: "CommercialRelationshipDocument"
        });
        this.$store.dispatch("product/companyNameListedOnAOCorACC", { productType: "commercial", value })
      }
    }
  },
  watch: {
    "productTypes.commercial.productInfo.maintServiceProvider": {
      handler: function(newVal) {
        if (newVal) {
          this.productTypes.commercial.productInfo.serviceProviderDetails = "";
          this.$v.productTypes.commercial.productInfo.serviceProviderDetails.$reset();
        }
      }
    },
    "productTypes.commercial.productInfo.billOfSale": {
      handler: function(newVal) {
        if (newVal == "yes") {
          // remove AssetDocument
          this.$store.dispatch("files/removeFile", "AssetDocument");
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "AssetDocument"
          });
          // remove AuthLetterDocument
          this.$store.dispatch("files/removeFile", "AuthLetterDocument");
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "AuthLetterDocument"
          });
        } else {
          // remove BillOfSaleDocument
          this.$store.dispatch("files/removeFile", "BillOfSaleDocument");
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "BillOfSaleDocument"
          });
        }
      }
    },
    "productTypes.commercial.productInfo.noAirOperatorCertificate": {
      handler: function(newVal) {
        if (newVal) {
          this.$store.dispatch("files/removeFile", "CommercialOperatorCertificate");
          this.$store.dispatch("files/removeFile", "CommercialOperatorSpecDocument");
          this.$store.dispatch("files/removeFile", "CommercialRelationshipDocument");
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "CommercialOperatorCertificate"
          });
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "CommercialOperatorSpecDocument"
          });
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "CommercialRelationshipDocument"
          });
        } else {
          // remove LeaseAgreementCertificate
          this.$store.dispatch("files/removeFile", "LeaseAgreementCertificate");
          this.$store.dispatch("product/removeFileMetaData", {
            productType: "commercial",
            documentType: "LeaseAgreementCertificate"
          });
        }
      }
    },
    "commercialOperatorCertificate": {
      handler: function() {
        this.companyNameListedOnAOCorACC = null;
        this.$store.dispatch("files/removeFile", "CommercialRelationshipDocument");
        this.$store.dispatch("product/removeFileMetaData", {
          productType: "commercial",
          documentType: "CommercialRelationshipDocument"
        });
      }
    }
  },
  created() {
    if (this.$store.state.vuealidate.hasOwnProperty("Product Information - Commercial Engines")) {
      this.$v.$touch();
    }
  },
  beforeDestroy() {
    this.$v.$touch();
    this.$store.dispatch("vuealidate/saveValidation", {
      componentName: "Product Information - Commercial Engines",
      $v: this.$v
    });
  },
  validations: {
    productTypes: {
      commercial: {
        productInfo: {
          engineDetails: {
            required,
            $each: {
              engineModel: {
                required
              },
              otherEngineModel: {
                required: requiredIf(function(engine) {
                  return engine.engineModel === "Other";
                })
              },
              otherAircraftType: {
                required: requiredIf(function(engine) {
                  return engine.aircraftType === "Other";
                })
              },
              aircraftNumber: {
                numeric,
                maxLength: maxLength(8)
              }
            }
          },
          serviceProviderDetails: {
            required: requiredIf(function() {
              return this.$store.state.product.productTypes["commercial"].productInfo.maintServiceProvider == "yes";
            }),
            maxLength: maxLength(500)
          }
        }
      }
    },
    commercialFleetSummaryDocument: {
      required: requiredIf(function() {
        return this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId != "6";
      })
    },
    commercialOperatorCertificate: {
      required: requiredIf(function() {
        if (
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "3"
        ) {
          return false;
        } else {
          return !this.productTypes.commercial.productInfo.noAirOperatorCertificate;
        }
      })
    },
    leaseAgreementCertificate: {
      required: requiredIf(function() {
        if (this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6") {
          return false;
        } else {
          return this.productTypes.commercial.productInfo.noAirOperatorCertificate;
        }
      })
    },
    commercialOperatorSpecDocument: {
      required: requiredIf(function() {
        if (
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "3"
        ) {
          return false;
        } else {
          return !this.productTypes.commercial.productInfo.noAirOperatorCertificate;
        }
      })
    },
    billOfSaleDocument: {
      required: requiredIf(function() {
        return this.productTypes.commercial.productInfo.billOfSale == "yes";
      })
    },
    authLetterDocument: {
      required: requiredIf(function() {
        if (
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "1"
        ) {
          return false;
        } else {
          return this.productTypes.commercial.productInfo.billOfSale == "no";
        }
      })
    },
    assetDocument: {
      required: requiredIf(function() {
        if (
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "1"
        ) {
          return false;
        } else {
          return this.productTypes.commercial.productInfo.billOfSale == "no";
        }
      })
    },
    commercialRelationshipDocument: {
      required: requiredIf(function() {
        if (
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
          this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "3"
        ) {
          return false;
        } else {
          return this.companyNameListedOnAOCorACC === 'No';
        }
      })
    },
    companyNameListedOnAOCorACC: {
      required: requiredIf(function() {
        return this.commercialOperatorCertificate != "";
      })
    }
  },
  methods: {
    getDocumentStatus(docType) {
      let status = "";
      let storedDocs = this.$store.state.product.productTypes["commercial"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == docType) {
            status = storedDocs[i].status;
            break;
          }
        }
      }
      return status;
    },
    gotoNextSection() {
      this.$emit("next", "ProductInfoCommercial");
    },
    checkVisibility: function() {
      return !(this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6");
    },
    checkVisibilityForAttchment: function() {
      return !(this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6");
    },
    checkBOSVisibility: function() {
      return !(
        this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
        this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "1"
      );
    },
    checkAocVisibility: function() {
      return !(
        this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "6" ||
        this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "3"
      );
    }
  }
};
</script>
<style lang="less" scoped>
label {
  font-weight: bold;
}
.ml {
  margin-left: 5px;
}
#companyNameListedOnAOCorACC {
  width: 70px;
}
.aoc-radio-btns {
  padding-left: 10px;
  .radio-inline {
    padding-right: 15px;
    cursor: pointer;
    font-weight: normal;
    input[type="radio"] {
      cursor: pointer;
    }
    span {
      vertical-align: middle;
    }
  }
}
</style>
